import visit from 'unist-util-visit';
import stringify from 'nlcst-to-string';
import syllable from 'syllable';
import { TextAnalysis, TextAnalysisCategory, TextAnalysisResult } from '../SermonAnalyzer';

export default function ReadingScore() {

    const minWords:number = 4;

    let fleschScore:number[] = [];

    return transformer;
    
    function transformer(tree: any, file: any) {
        visit(tree, 'SentenceNode', gather);
        
        function gather(sentence: any) {
            let totalSyllables:number = 0;
            let wordCount:number = 0;
            let counts;

            visit(sentence, 'WordNode', visitor)

            if (wordCount >= minWords) {
                counts = {
                syllable: totalSyllables,
                sentence: 1,
                word: wordCount,
                };

                fleschScore.push(flesch(counts));
            }

            return visit.SKIP

            function visitor(node: any) {
                let value:string = stringify(node);
                let syllables:number = syllable(value);
                wordCount++;
                totalSyllables += syllables;
            }
        }
        
        let fleschAvg:number = fleschScore.length > 0 ? Math.round(Math.floor((fleschScore.reduce((a,b) => a + b)) / fleschScore.length)) : 0;

        let readingEase:TextAnalysis = getReadingScoreText(fleschAvg);

        if(readingEase.result === TextAnalysisResult.improvement){ 
            file.improvements.push(readingEase);
        } else { 
            file.goodResults.push(readingEase);
        }
    }
        
    function getReadingScoreText(score:number) {
        let result:TextAnalysis = {title: TextAnalysisCategory.flesch_reading_ease, displayText: "", helperText: "Reading score calculated using the Flesch Reading Ease scale"};
        if(score < 60) {
            result.displayText = `Uh oh, it looks like your sermon may be difficult to read. Remember to keep paragraphs short, somewhere around five sentences. Include more action words, write shorter sentences, and try to keep your thoughts simple and clear.`;
            result.result = TextAnalysisResult.improvement;
        } else { 
            result.displayText = `Nicely done, it looks like your sermon is easy to read. You’ve kept paragraphs short, with clear and simple sentences. Keep up the good work.`;
            result.result = TextAnalysisResult.goodResult;
        }
        return result;
    }

    function flesch(counts:any){
        let sentenceWeight = 1.015
        let wordWeight = 84.6
        let base = 206.835
        
        if (!counts || !counts.sentence || !counts.word || !counts.syllable) {
            return NaN
        }
        
        return (
            base -
            sentenceWeight * (counts.word / counts.sentence) -
            wordWeight * (counts.syllable / counts.word)
        )
    }
}